import React, { useEffect, useState } from 'react'
import Slider from "react-slick"; 
import { getGallery } from '../Service/Api'

const Achievement = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true); 
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const galleryData1 = await getGallery();
          const galleryData = galleryData1.filter((item) => item.category === 'Achievement')
          setData(galleryData);
        } catch (error) {
          console.error("Error fetching gallery data:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);
    const settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 2000,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        adaptiveHeight: true,
        
      };
      const emptyArray = [
        {id:1}, 
        {id:2}, 
      ]
  return (
     <>
      <Slider {...settings}>
      {data.length > 0 ? (data.map((item,index) =>   ( 
        <div className="item" key={index}>
        <div className="achievementsec">
            <div className="achievementsecimg">
            <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item.attachments[0]}`}><img
              src={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
              alt={item.title} // Use item title as alt text for better accessibility
              className="img-fluid"
            />
            </a>
            </div>
            <h5>{item.name}</h5>
            <p>{item.title}</p>
          </div>
      </div> 

    ))) : 
emptyArray.map((item) => (
<div className="item" key={item.id}>
<div className="achievementsec">
            <div className="achievementsecimg">
              <img
              src="https://webapi.entab.info/api/image/JRPSB/public/Images/gal-1.jpg"
              alt={item.title} // Use item title as alt text for better accessibility
              className="img-fluid"
            />
              
            </div>
            <h5>Name</h5>
            <p>Achievement  </p>
          </div>
</div>
    ))
}
      </Slider>
     </>
  )
}

export default Achievement
